export const LeftAlignSvg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5787 1.24976H1.42132C0.635533 1.24976 0 1.88529 0 2.67108C0 3.45686 0.635533 4.0924 1.42132 4.0924H18.5787C19.3645 4.0924 20 3.45686 20 2.67108C20 1.88529 19.3645 1.24976 18.5787 1.24976Z"
        fill="currentColor"
      />
      <path
        d="M20 12.4438C20 11.658 19.3645 11.0225 18.5787 11.0225H1.42132C0.635533 11.0225 0 11.658 0 12.4438C0 13.2295 0.635533 13.8651 1.42132 13.8651H18.5787C19.3645 13.8651 20 13.2275 20 12.4438Z"
        fill="currentColor"
      />
      <path
        d="M1.42132 8.97765H15.5411C16.3269 8.97765 16.9624 8.34212 16.9624 7.55633C16.9624 6.77054 16.3269 6.13501 15.5411 6.13501H1.42132C0.635533 6.13501 0 6.77054 0 7.55633C0 8.34212 0.635533 8.97765 1.42132 8.97765Z"
        fill="currentColor"
      />
      <path
        d="M12.0264 17.329C12.0264 16.5432 11.3909 15.9077 10.6051 15.9077H1.42132C0.635533 15.9077 0 16.5432 0 17.329C0 18.1148 0.635533 18.7504 1.42132 18.7504H10.6051C11.3909 18.7504 12.0264 18.1148 12.0264 17.329Z"
        fill="currentColor"
      />
    </svg>
  );
};
